import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconNote: React.FC<IconProps> = ({ width = 16, height = 16 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clip-path="url(#clip0_5704_15674)">
                <path
                    d="M15.4999 2.5H14.7499V1.75C14.7499 1.6837 14.7236 1.62011 14.6767 1.57322C14.6298 1.52634 14.5663 1.5 14.4999 1.5H13.7454C13.7477 1.2535 13.7499 1.00625 13.7499 0.75C13.7499 0.683696 13.7236 0.620107 13.6767 0.573223C13.6298 0.526339 13.5663 0.5 13.4999 0.5H2.49995C2.43364 0.5 2.37005 0.526339 2.32317 0.573223C2.27629 0.620107 2.24995 0.683696 2.24995 0.75C2.24995 10.9307 0.340197 13.0553 0.323197 13.0732C0.288244 13.1082 0.264443 13.1528 0.254801 13.2012C0.245159 13.2497 0.25011 13.3 0.269027 13.3457C0.287945 13.3913 0.31998 13.4304 0.361082 13.4579C0.402185 13.4853 0.450509 13.5 0.499947 13.5H3.24995V14.25C3.24995 14.3163 3.27629 14.3799 3.32317 14.4268C3.37005 14.4737 3.43364 14.5 3.49995 14.5H4.24995V15.25C4.24995 15.3163 4.27629 15.3799 4.32317 15.4268C4.37005 15.4737 4.43364 15.5 4.49995 15.5H15.4999C15.5663 15.5 15.6298 15.4737 15.6767 15.4268C15.7236 15.3799 15.7499 15.3163 15.7499 15.25V2.75C15.7499 2.6837 15.7236 2.62011 15.6767 2.57322C15.6298 2.52634 15.5663 2.5 15.4999 2.5ZM2.74995 1H13.2499C13.2222 9.9695 11.6977 12.559 11.3807 13H0.972947C1.5417 12 2.72495 8.96475 2.74995 1ZM3.74995 13.5H11.4999C11.5662 13.5 11.6298 13.4736 11.6767 13.4268C11.7579 13.3455 13.5879 11.3982 13.7389 2H14.2499V14H3.74995V13.5ZM15.2499 15H4.74995V14.5H14.4999C14.5663 14.5 14.6298 14.4737 14.6767 14.4268C14.7236 14.3799 14.7499 14.3163 14.7499 14.25V3H15.2499V15Z"
                    fill="black"
                />
            </g>
            <defs>
                <clipPath id="clip0_5704_15674">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconNote;
